import { render, staticRenderFns } from "./FactorArgumentsModal.vue?vue&type=template&id=a991e688&scoped=true&"
import script from "./FactorArgumentsModal.vue?vue&type=script&lang=js&"
export * from "./FactorArgumentsModal.vue?vue&type=script&lang=js&"
import style0 from "./FactorArgumentsModal.vue?vue&type=style&index=0&id=a991e688&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a991e688",
  null
  
)

export default component.exports